import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getUoms(currUserId) {
        const url = `${config.cloudFunctionsBaseUrl}/getUoms`;
        return axios.post(url, {
            currUserId: currUserId
        });
    },
}
